/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { parseError } from '@modules/cloud-lib/users/hooks/webauthn'
import type { ApiErrorCollection } from '@modules/query/types'

// Error code E0000011 in the error's message comes from Okta.
// This signals when the state token has expired or is invalid.
// When this error occurs, the user is not able to send any more requests
// with the invalid or expired token and should start a new authentication flow
export function hasExpiredOktaStateTokenError(error: ApiErrorCollection | string | null): boolean {
  const errorMessage = parseError(error)
  return errorMessage ? errorMessage.includes('E0000011') : false
}
